import { Fragment } from "react";
import BoxTitle from "../../../TEMPLATE/components/box/title/BoxTitle";
import { applicantsCitizen } from "../../hardCodeData/DATA";
import { useHistory } from "react-router-dom";

const Advertisement = ({ title, external, internal, img }) => {
  const history = useHistory();
  return (
    <Fragment>
      <BoxTitle
        title={title}
        infoContext={""}
        externalLink={external}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
      />
      <div
        style={{
          width: "180px",
          height: "180px",
          background: "rgb(86, 138, 9)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "50%",
          margin: "10px auto",
          cursor: "pointer",
        }}
      >
        <img
          src={img}
          alt={`${title} - image`}
          width={160}
          onClick={() => {
            if (external) window.open(`${external}`, "_blank");
            else if (internal) history.push(`/${internal}`);
          }}
        />
      </div>
    </Fragment>
  );
};
export default Advertisement;
